import React from 'react'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import AddField from '@/components/addField/AddField'
import ActionButton from '@/components/buttons/ActionButton'
import SendIcon from '@mui/icons-material/Send'
import { useNavigate } from 'react-router-dom'
import { useLazyRequestChangePasswordQuery } from '@/store/apis/auth'

const RequestChangePassword: React.FC = () => {
  const [requestChangePasswordQuery, { isFetching }] =
    useLazyRequestChangePasswordQuery()
  const { t } = useTranslation('default')
  const navigate = useNavigate()
  const [email, setEmail] = React.useState<string>('')
  const [isSent, setIsSent] = React.useState<boolean>(false)

  const sendEmail = async (event?: React.SyntheticEvent) => {
    event && event.preventDefault()
    if (email) {
      await requestChangePasswordQuery({ email })
      setIsSent(true)
    }
  }

  return (
    <form onSubmit={sendEmail}>
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        spacing={3}
      >
        {!isSent ? (
          <>
            <Grid item>
              <Typography component="h1" align="center">
                {t('login.requestChangePasswordDescription')}
              </Typography>
            </Grid>
            <Grid item>
              <AddField
                label={t('login.email')}
                type="email"
                supressEmptyError
                required={true}
                value={email}
                onChange={(newValue) => setEmail(newValue)}
              />
            </Grid>
            <Grid item>
              <ActionButton
                icon={<SendIcon />}
                isLoading={isFetching}
                label={t('login.sendMail')}
                onClick={sendEmail}
                type="submit"
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item>
              <Typography component="h1">{t('login.requestSent')}</Typography>
            </Grid>
          </>
        )}
        <Grid item>
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate('/')}
          >
            {t('login.backToLogin')}
          </Link>
        </Grid>
      </Grid>
    </form>
  )
}

export default RequestChangePassword
